<template>
  <div class="guid-list" :class="{ col: dir === 'col'}">
    <div
      v-for="(block, i) in guidList"
      :key="i"
      class="guid-list_block"
    >
      <div
        v-for="(item, index) in block"
        :key="index"
      >
        <div
          v-if="item.type === 'img'"
          class="guid-list_img_container"
        >
          <img
            :src="item.content"
          >
        </div>
        <div v-if="item.type === 'slot' && !isOnlyImg" class="guid-list_text_container">
          <slot />
        </div>
        <ul
          v-if="item.type === 'txt' && !isOnlyImg"
          class="guid-list_text_container"
        >
          <li v-for="(txt, i) in item.content" :key="i">
            <div v-html="txt" />
          <!-- {{ txt }} -->
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    guid: {
      typeof: Object,
      default: () => ({})
    },
    isOnlyImg: {
      typeof: Boolean,
      default: false
    },
    dir: {
      type: String,
      default: 'row'
    }
  },
  data() {
    return {
      guidList: [],
    };
  },
  created() {
    
  },
  mounted() {
    const guidList = (this.guid.DataList || []).map(item => {
      let content = null;

      if (item.Type === 'img') {
        content = item.Value
      } else if (item.Type === 'txt') {
        content = ((item.Value || '').split(/(\r|\n)/) || [])
          .filter(item => !!item && !['\r', '\n'].includes(item)) //.replace(/(\r|\n)/g, '<br>');
      } else {
        content = item.Value
      }

      return {
        type: item.Type,
        content
      }
    })

    const firstTextIndex = guidList.findIndex(item => item.type === 'txt');

    if (Number.isInteger(firstTextIndex)) {
      guidList.splice(firstTextIndex, 0, {
        type: 'slot',
      })
    }

    const guidListBlock = [];
    let insertIndex = 0;

    guidList.forEach(item => {
      if (!guidListBlock[insertIndex]) guidListBlock[insertIndex] = [];

      guidListBlock[insertIndex].push(item);

      if (item.type === 'txt') insertIndex += 1;
    })

    this.guidList = guidListBlock;
  },
  destroyed() {
  },
  methods: {
  }
};
</script>

<style scoped="scoped" lang="scss">
.guid-list {
  display: flex;
  align-items: flex-start;
  justify-content: center;

  &.col {
    flex-direction: column; 
  }

  &_img_container {
    width: 250px;
    min-height: 254px;
    margin: 10px auto;
    img {
      width: 100%;
    }
  }

  &_block {
    margin-right: 30px;
    &:nth-child(2) {
      .guid-list_text_container {
        margin-top: 44px;
      }
    }
  }

  &_text_container {
    width: 400px;
    margin: 0 auto 12px;

    li {
      padding: 2px 0;
      line-height: 22px;
      color: #777;
    }
  }
}
</style>
